var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcFavOn = function SvgIcFavOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D80C18",
    d: "M15.402.007A6.23 6.23 0 0 0 11.237 1.9L11 2.142l-.237-.244a6.186 6.186 0 0 0-8.917 0c-2.46 2.529-2.46 6.627 0 9.156l8.387 8.62a1.066 1.066 0 0 0 1.536 0l8.386-8.62A6.56 6.56 0 0 0 22 6.475a6.56 6.56 0 0 0-1.846-4.578A6.22 6.22 0 0 0 15.696 0z"
  })));
};
export default SvgIcFavOn;